import { isUndefined, noop } from 'lodash';
import { ChangeEvent, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'components/Button';
import { SelectInput } from 'components/Forms';
import { Heading } from 'components/Typography';
import { ContactInfoContext, withContactInfoMachineState } from 'domains/signup/contactInfo/data/ContactInfoContext';
import { stateOptions } from 'utils/states';

type Props = {
  defaultValue?: string;
  onSubmit: (value: string) => void;
};

const EnterState: React.FC<Props> = ({ defaultValue, onSubmit }) => {
  const [value, setValue] = useState(defaultValue);

  const { t } = useTranslation();

  return (
    <>
      <Heading level="h2" className="mb-64 sm-d:mb-40">
        {t('signup.steps.enterState.title')}
      </Heading>

      <SelectInput
        data-testid="state-select"
        allowEmpty
        label={t('signup.steps.enterState.stateFieldTitle')}
        options={stateOptions}
        name="state"
        value={value}
        onChange={(e: ChangeEvent<HTMLSelectElement>) => setValue(e.target.value)}
        clearValue={noop}
        setError={noop}
        setValue={noop}
        disabled={false}
      />

      <Button
        data-testid="state-submit-button"
        size="lg"
        disabled={isUndefined(value) || value.length === 0}
        className="mt-64 sm-d:mt-40 sm-d:w-full"
        onClick={() => {
          onSubmit(value as string);
        }}
      >
        {t('signup.steps.enterState.submit')}
      </Button>
    </>
  );
};

const ContactInfoWrapper = () => {
  const state = ContactInfoContext.useSelector(({ context }) => context.state);
  const { send } = ContactInfoContext.useActorRef();

  const onSubmit = useCallback(
    (value: string) => {
      send({
        type: 'submitState',
        state: value as string,
      });
    },
    [send],
  );

  return <EnterState defaultValue={state} onSubmit={onSubmit} />;
};

export const ContactInfoEnterState = withContactInfoMachineState(ContactInfoWrapper, 'enterState');
